
<template>
  <div>
    <Form style="margin: 30px 20px 0px 0px" :model="formItem" :disabled="loading" :label-width="100" label-position="left"  >
      <div class="formRow">
        <div class="formCol">
          <FormItem label="分类名称：">
            <Input v-model="formItem.listTypeName" />
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="可见角色：">
            <Select  filterable clearable v-model="formItem.roleId"  >
              <Option
              v-for="(item, i) in RoleLabel"
              :value="item.roleId"
              :key="i"
              >{{ item.roleName }}</Option
              >
          </Select>
          </FormItem>
        </div>
        <div class="formCol">
          <Button type="primary" @click = "searchData"><!-- 检索 -->{{$t('Search')}}</Button>
        </div>
      </div>
    </Form>
    <div>
      <Table border ref="table" :loading="loading" :columns="internationalColumns" :data="internationalData"> 
        <template slot-scope="{ row, index }" slot="action">
          <Button icon="md-create" type="warning" size="small" style="margin-right: 8px" @click="editBtn(row,index)">编辑</Button>
          <Button icon="md-trash" type="error" size="small" @click="deletedbtn(row,index)">删除</Button>
        </template>
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page :total="total" :page-size="pageInfo.pageSize" @on-change="pageChange" />
        </Col>
        <Col span="5" style="text-align:right;">
          <Button icon="md-add" type="primary" @click="addBtn()" :disabled="loading">新增</Button>
        </Col>
      </Row>
    </div>
    <!-- :title="internationalColumns[transferType+1].title" -->
    <Modal width="55%" v-model="visualPop" :title="showTitle">
      <Form :label-width="100" label-position="left" >
        <FormItem label="分类名称：">
          <Input v-model="formItem1.listTypeName"/>
        </FormItem>
      </Form>
        <TabsTransferComponent v-if="visualPop" :transferData="transferData" 
        transferTitle="显示字段" @transferChange="transferChange"></TabsTransferComponent>
      <Form :label-width="100" label-position="left" ref="formValidate" :rules="ruleValidate" :model="formItem1">
        <FormItem label="是否通用" style="margin-top:24px">
          <RadioGroup v-model="formItem1.beCommon" @on-change="beCommonChange">
            <Radio v-for="item in becommentList" :label="item.value" :key="item.value">{{item.label}}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="显示角色" v-if="domCheck" :prop="formItem1.beCommon=='0'?'roleId':''"> 
          <Select :clearable="true" ref="resetSelect" v-model="formItem1.roleId" :disabled="roleDisable" placeholder="">
            <Option v-for="item in ShowRoles" :value="item.roleId" :key="item.roleId">{{ item.roleName }}</Option>
          </Select>
        </FormItem>
      
      </Form>
      <div class="bottomBtn" slot="footer">
          <Button type="primary" @click="saveData()" style="margin-left:15px">保存</Button>
          <Button @click="cancel()">取消</Button>
      </div>
    </Modal>   
  </div>
</template>
  
<script>
import axios from 'axios'
import TabsTransferComponent from './components/TabsTransferComponent'
export default {
  components:{
      TabsTransferComponent
  },
  data() {
    return {
      loading:false,
      plan : '',
      formItem: {
      },
      pageInfo : {
          pageNo : 1,
          pageSize: 10,
      },
      total : 0,
      internationalColumns: [
        {
            title: '分类名称',
            key: 'listTypeName',
            align: "center"
        },
        {
            title: '可见角色',
            align: "center",
            // slot: "slot",
            key:"roleId",
            render: (h, params) => {
              return h(
                "span",
                this.RoleLabel.filter(item => item.roleId==params.row.roleId).map(res => res.roleName)
                );
            },
        },
        {
            title: '是否通用',
            align: "center",
            // slot: "slot",
            key:"beCommon",
            render: (h, params) => {
              return h(
              "span",
              params.row.beCommon == "0" ? "否" : params.row.beCommon == "1" ? "是" : ""
              );
            },   
        },
        {
          title: "操作",
          slot: 'action',
          align: 'center',
          width:"200"
        }
      ],
      RoleLabel:[],
      internationalData:[],
      visualPop:false,
      transferData:[],
      transferTitle:'',
      transferType:'',
      ShowRoles:[],
      showTitle:'',
      formItem1:{
        beCommon:'0',
        roleId:''
      },
      becommentList:[  
        {
          label:'否',
          value:"0",
        },
        {
          label:'是',
          value:"1",
        },
      ],
      updatedData:[],
      id:'',
      roleDisable:false,
      ruleValidate:{
        roleId: [
            { required: true, message: '请选择角色',trigger: 'change' }
        ],
      },
      domCheck:true
    };
  },
  created() {
    this.searchData()
    this.selectRoleLabel()
  },
  methods: {
    beCommonChange(){
      if(this.formItem1.beCommon==1){
        this.$refs.resetSelect.clearSingleSelect()
        this.roleDisable = true
        this.$forceUpdate()
      }else{
        this.roleDisable = false
      }
      this.domUpdate()
    },
    pageChange(val){
      this.pageInfo.pageNo = val
      this.searchData()
    },
    selectRoleLabel(){
      let Obj ={}
      axios.post("/userListRole/selectRoleLabel",Obj).then((res) => {
          this.RoleLabel = res
      })
    },
    // 检索查询
    searchData(){
      this.loading=true
      let Obj = {
        pageNo : this.pageInfo.pageNo,
        pageSize : this.pageInfo.pageSize,
        roleId : this.formItem.roleId,
        listTypeName : this.formItem.listTypeName,
        sheetIdList:["agency_services","basic_information","health_information","personnel_information"]
      }
      axios.post("/userListRole/selectUserListRoleSetData",Obj).then((res) => {
        this.loading=false
        if(res){
          this.internationalData = res.data
          this.total = Number(res.pageInfo.total)
        }
      })
    },
    searchOption(){
      axios.post("/remindModule/selectAllRemindRoleData", {}).then((res) => {
          if(res){
            this.ShowRoles = res
          }
        })
    },
    addBtn(){
      this.transferData=[]
      this.visualPop = true
      this.showTitle = '新增'
      this.searchOption()

      this.formItem1 = {
        beCommon:'0',
        roleId:''
      }
      this.beCommonChange()
      // 查询可见内容
      let Obj = {
        id:'',
        "sheetIdList":["agency_services","basic_information","health_information","personnel_information"]
      }
      axios.post("/userListRole/selectUserListRoleSetData",Obj).then((res) => {
        if(res){
          this.transferData = res[0].userSheetSetList.map((el) => {
              return{
                ...el,
                key:el.showKey,
                label:el.chName,
                content:el.beShowUser
              }
          })
        }
      })
    },

    editBtn(row,index){
      this.transferData=[]
      this.showTitle = '编辑'
      this.visualPop = true
      this.searchOption()
      
      this.formItem1.listTypeName = row.listTypeName
      this.formItem1.roleId = row.roleId
      this.formItem1.beCommon = row.beCommon
      this.id = row.id
      this.beCommonChange()
      // 查询可见内容
      let Obj = {
        id:row.id,
      }
      axios.post("/userListRole/selectUserListRoleSetData",Obj).then((res) => {
        if(res){
          this.transferData = res[0].userSheetSetList.map(el=>{
              return{
                ...el,
                key:el.showKey,
                label:el.chName,
                type:el.isNeedShow
              }
          })
        }
      })
    },
    
    transferChange(item){
      this.updatedData=[]
      this.transferData.forEach(res => {
        item.forEach(element => {
            if(res.showKey==element){
                this.updatedData.push({showKey:res.showKey,chName:res.chName,enName:res.enName})
            }
        });
      })
    },
    
    saveData(){
      this.$refs.formValidate.validate((valid) => {
          if (valid) {
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                content: '',
                onOk: () => {
                    this.sureSave()
                }
            });
          } 
      })
      
    },
    sureSave(){
      if(this.showTitle=="编辑"){
        let obj = {
          id : this.id,
          listTypeName : this.formItem1.listTypeName,
          roleId : this.formItem1.roleId,
          beCommon : this.formItem1.beCommon,
          userListColumnSetList: this.updatedData
        }
        axios.post("/userListRole/updateUserListRoleSetData", obj).then((res) => {
          if(res){
            this.searchData()
            this.visualPop = false
          }
        })
      }else{
        let obj = {
          listTypeName : this.formItem1.listTypeName,
          roleId : this.formItem1.roleId,
          beCommon : this.formItem1.beCommon,
          userListColumnSetList: this.updatedData
        }
        axios.post("/userListRole/insertUserListRoleSetData", obj).then((res) => {
          if(res){
            this.searchData()
          }
          this.visualPop = false
        })
      }
    },
    cancel(){
      this.visualPop = false
    },

    deletedbtn(row){
      this.$Modal.confirm({
          title: this.$notice('deletion'),
          content: '',
          onOk: () => {
              let obj={
                id:row.id
              }
              axios.post("/userListRole/deleteUserListRoleSetData", obj).then((res) => {
                this.searchData()
              })
          }
      });
    },
    domUpdate(){
      this.domCheck=false
      this.$nextTick(() => {
        this.domCheck=true
      })
    },
    
  },
};
</script>
  
<style scoped>
.formRow {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.formCol {
    width: calc((100% - 210px) / 3);
    float: left;
    /* margin-right: 30px; */
}
.bottomBtn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.ivu-date-picker {
    width:100%
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/fileInternationalViewSet.vue